module.exports = __webpack_public_path__ + "static/media/4_spēlētāji.7fb43cd8.svg";